import React, { useEffect, useState } from 'react';
import { TextImageProps } from './types/RenderOptions';
import renderTextImage from './rendering/renderTextImage';

const TextImage: React.FC<TextImageProps> = ({ id, name, words, style, config }) => {
    const [image, setImage] = useState({ src: '', error: '' });
    useEffect(() => {
        let cancelled = false;
        setImage({ src: '', error: '' });
        const render = async () => {
            try {
                // Font loading must finish before measuring or exporting the canvas.
                const fonts = (document as Document & {
                    fonts?: { load(font: string): Promise<unknown> };
                }).fonts;
                if (fonts) {
                    await Promise.all([
                        fonts.load(`${style.size}pt ${style.font}`),
                        fonts.load(`italic ${Math.round(style.size * 0.55)}pt FiraI`),
                    ]);
                }
                if (cancelled) return;
                const canvas = renderTextImage({ words, style, config });
                setImage({ src: canvas.toDataURL(), error: '' });
            } catch (error) {
                if (!cancelled) setImage({ src: '', error: error.message });
            }
        };
        render();
        return () => { cancelled = true; };
    }, [words, style, config]);

    if (image.error) return <p role="alert">Could not render this panel: {image.error}</p>;
    const source = words.split(/\r?\n/).map((line) => line.split('|')[0]).join('');
    return <img id={id === undefined ? undefined : String(id)} {...{ name }}
        className="jumping-images" src={image.src || undefined} alt={source} />;
};

export default TextImage;
